import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { api } from '@/lib/api';
import { useAuthStore } from './authStore';

export function LoginPage() {
  const navigate = useNavigate();
  const setSession = useAuthStore((s) => s.setSession);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { email, password, device_name: 'web' });
      setSession(data.token, data.data);
      navigate('/');
    } catch (err: any) {
      setError(err?.response?.data?.message ?? 'Error de login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8">
          <img src={`${import.meta.env.BASE_URL}favicon.svg`} alt="" className="w-10 h-10" aria-hidden="true" />
          <div>
            <h1
              className="text-lg font-medium text-notion-800 leading-tight tracking-tight"
              style={{ fontFamily: "'JetBrains Mono', 'SF Mono', Menlo, monospace" }}
            >
              notas_de_cata
            </h1>
            <p
              className="text-[11px] text-notion-500 tracking-[0.15em] uppercase mt-0.5"
              style={{ fontFamily: "'JetBrains Mono', 'SF Mono', Menlo, monospace" }}
            >
              cava · inventario · mercado
            </p>
          </div>
        </div>

        <h2 className="text-xl font-medium text-notion-800 mb-1">Iniciar sesión</h2>
        <p className="text-[13px] text-notion-600 mb-6">
          Ingresá con tu cuenta para acceder a tu cava.
        </p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label" htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              required
              autoComplete="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label className="label" htmlFor="password">Contraseña</label>
            <input
              id="password"
              type="password"
              required
              autoComplete="current-password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {error && (
            <p className="text-[13px] text-negative bg-notion-50 border border-notion-200 px-3 py-2 rounded">
              {error}
            </p>
          )}

          <button type="submit" className="btn-primary w-full" disabled={loading}>
            {loading ? 'Entrando…' : 'Iniciar sesión'}
          </button>

          <p className="text-[13px] text-center text-notion-600 pt-2">
            ¿Primera vez?{' '}
            <Link to="/register" className="text-notion-800 underline underline-offset-2 hover:text-notion-900">
              Crear cuenta
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
